import { AUTH_PATHS } from '@coachmate/auth/auth.routes'
import { TEAM_PATHS } from '@coachmate/team/team.routes'
import { DOWNLOAD_PATHS } from '@coachmate/download/download.routes'
import { CLASSROOM_PATHS } from '@coachmate/classroom'

export type RouterPath =
  | '/'
  | '/error'
  | (typeof AUTH_PATHS)[number]
  | (typeof TEAM_PATHS)[number]
  | (typeof DOWNLOAD_PATHS)[number]
  | (typeof CLASSROOM_PATHS)[number]
export const ROUTES = [...AUTH_PATHS, ...TEAM_PATHS, ...DOWNLOAD_PATHS, ...CLASSROOM_PATHS] as const
